import { showToast } from "components/toast/Toast"; // Assuming you have similar constants for plan types
import { GET_SINGLE_FEATURE } from "constants/endpoints";
import { FEATURES_LISTING_API } from "constants/endpoints";
import { CREATE_PLAN_API } from "constants/endpoints"; // Import the endpoint for creating plans

export const createPlan = async ({ apiCall, payload }) => {
  try {
    // Determine the URL based on the form type if necessary, or directly use the CREATE_PLAN_API
    const url = CREATE_PLAN_API;
    const method = payload?.plan_id ? 'patch' : 'post'; // Use 'patch' for updates and 'post' for creation


    // Make the API call
    const response = await apiCall[method](url, payload);

    // Show success message
    if (response) {
      showToast({
        message: "Plan has been successfully submitted",
        success: true,
        customStyle: {
          background: "#52c41a",
          color: "#fff",
          padding: "10px",
        },
      });
    }

    return response;
  } catch (error) {
    console.error("Error creating/updating plan:", error);

    // Show error message
    showToast({
      message: error?.response?.data?.error?.message
        ? error?.response?.data?.error?.message
        : error?.response?.data?.error || "An error occurred while submitting the plan.",
      success: false,
      customStyle: {
        background: "#F24052",
        color: "#fff",
        padding: "10px",
      },
    });

    // Throw the error message
    throw error?.response?.data?.error?.message
      ? error?.response?.data?.error?.message
      : error?.response?.data?.error || "An error occurred while submitting the plan.";
  }
};


export const getFormData = async ({ apiCall, propertyId}) => {
  try {
    const url = `${CREATE_PLAN_API}/${propertyId}`;
    const response = await apiCall.get(url);
    return response?.data?.respose;
  } catch (error) {
    console.error("Error fetching form:", error);
    const errorMessage = error;
    if(errorMessage){
      showToast({
        message: errorMessage,
        success: false,
        customStyle: {
          background: "#F24052",
          color: "#fff",
          padding: "10px",
        },
      });
    }
    throw errorMessage ? errorMessage : error;
  }
};

export const getSingleFeatureData = async ({ apiCall, featureId}) => {
  try {
    const url = `${GET_SINGLE_FEATURE}/${featureId}`;
    const response = await apiCall.get(url);
    return response?.data;
  } catch (error) {
    console.error("Error fetching form:", error);
    const errorMessage = error;
    if(errorMessage){
      showToast({
        message: errorMessage,
        success: false,
        customStyle: {
          background: "#F24052",
          color: "#fff",
          padding: "10px",
        },
      });
    }
    throw errorMessage ? errorMessage : error;
  }
};

export const createFeature = async ({ apiCall, payload }) => {
  try {
    const response = await apiCall.post(FEATURES_LISTING_API, payload);

    if (response) {
      showToast({
        message: "Feature has been successfully submitted",
        success: true,
        customStyle: {
          background: "#52c41a",
          color: "#fff",
          padding: "10px",
        },
      });
    }

    return response;
  } catch (error) {
    console.error("Error creating/updating feature:", error);

    // Show error message
    showToast({
      message: error?.response?.data?.error?.message
        ? error?.response?.data?.error?.message
        : error?.response?.data?.error || "An error occurred while submitting the Feature.",
      success: false,
      customStyle: {
        background: "#F24052",
        color: "#fff",
        padding: "10px",
      },
    });

    // Throw the error message
    throw error?.response?.data?.error?.message
      ? error?.response?.data?.error?.message
      : error?.response?.data?.error || "An error occurred while submitting the Feature.";
  }
};